/**
 * Canonical legal entity and ABN for Trade Connector platform-issued documents.
 * Source: Master Agreement.
 */

export const PLATFORM_ENTITY = {
  name: 'Solar Cutter Solutions trading as Trade Connector',
  abn: '62 673 082 963',
  supportEmail: 'support@tradeconnector.com.au',
} as const;

export const PLATFORM_LEGAL_NAME = PLATFORM_ENTITY.name;
export const PLATFORM_ABN = PLATFORM_ENTITY.abn;
